"use client";

import React from "react";
import { Separator } from "@/components/ui/separator";
const chapters = [{
  title: "General Disclaimer",
  content: <>
        The information provided on this website is for general informational purposes only and is subject to change without prior notice.
        {"\n\n"}While <strong>KS Luxury Renovations LTD</strong>, operating under the brand <strong>KS Luxury Renovations</strong>, makes every effort to ensure that the content is accurate and up to date, no representations or warranties of any kind, express or implied, are made regarding the completeness, accuracy, reliability or availability of any information, properties, services or related graphics contained on the website.
        {"\n\n"}Any reliance you place on such information is strictly at your own risk.
      </>
}, {
  title: "Property Information Disclaimer",
  content: <>
        All property descriptions, specifications, floor plans, layouts, dimensions, images, renders and visual representations are indicative and for illustrative purposes only.
        {"\n\n"}Final construction details, materials, finishes and specifications may vary and are subject to change during the development process without prior notice. Computer-generated images (CGIs), renderings and marketing visuals are not contractual and may not reflect the final built product.
        {"\n\n"}Prospective buyers are advised to verify all information independently and consult with the developer or authorized representatives before making any purchasing decision.
      </>
}, {
  title: "Availability & Pricing",
  content: <>
        Property availability, pricing and terms are subject to change at any time without notice.
        {"\n\n"}Listings marked as “Available”, “Under Construction”, “Upcoming” or “Sold Out” are indicative and may change based on sales activity. Nothing on this website constitutes a binding offer or contract.
      </>
}, {
  title: "No Professional Advice",
  content: <>
        The content on this website does not constitute legal, financial, investment or real estate advice. Users are encouraged to seek independent professional advice before making any property purchase or investment decision.
      </>
}, {
  title: "Third-Party Links",
  content: <>
        This website may contain links to third-party websites for convenience. <strong>KS Luxury Renovations LTD</strong> does not control or endorse the content, policies or practices of any third-party websites and accepts no responsibility for them.
      </>
}, {
  title: "Limitation of Liability",
  content: <>
        To the fullest extent permitted by applicable law, <strong>KS Luxury Renovations LTD</strong> shall not be liable for any loss or damage, including without limitation indirect or consequential loss or damage, arising out of or in connection with the use of this website or reliance on its content.
      </>
}, {
  title: "Intellectual Property",
  content: <>
        All content on this website, including text, images, designs, graphics and branding elements, is the property of <strong>KS Luxury Renovations LTD</strong> unless otherwise stated. Unauthorized use, reproduction or distribution of any content is strictly prohibited.
      </>
}, {
  title: "Governing Law",
  content: <>
        This disclaimer shall be governed by and interpreted in accordance with the laws of the Republic of Cyprus.
      </>
}, {
  title: "Contact",
  content: <div className="whitespace-pre-line">
        If you have any questions regarding this Disclaimer, you may contact:
        {"\n\n"}<strong>KS Luxury Renovations LTD</strong>
        {"\n"}<strong>Aisopou 17, Agios Nikolaos, 3100, Limassol</strong>
        {"\n"}Email: ks@theksway.com
        {"\n"}Phone: +357 97 673 308
        {"\n"}<strong>Company registration number: 10405651Q</strong>
      </div>
}];
export default function BookContent() {
  return <section data-section-id="185128" id="disclaimer-content" className="bg-background text-foreground py-24">
      <div className="container mx-auto px-8 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          
          <div className="lg:col-span-8 xl:col-span-9">
            <div className="mt-8">
              <h1 className="font-default font-bold tracking-tight text-secondary !text-5xl">Disclaimer</h1>
              <span className="font-sans text-lg text-muted-foreground mt-4 block">
                Effective Date: April 2026
              </span>
            </div>

            <Separator className="my-8 bg-border" />

            <div className="space-y-12">
              {chapters.map((chapter, i) => <div key={i} data-index={i} className="py-4">
                  <h2 className="font-default font-bold mt-2 text-secondary !text-4xl">
                    {chapter.title}
                  </h2>
                  <div className="font-sans text-base md:text-lg leading-relaxed mt-6 text-muted-foreground whitespace-pre-line">
                    {chapter.content}
                  </div>
                </div>)}
            </div>
          </div>
          
          <div className="hidden lg:block lg:col-span-4 xl:col-span-3">
          </div>
        </div>
      </div>
    </section>;
}